import type { SelectPriceProps } from "~/ProductDetails/components/ProductSummary/PdpSummaryHelper";
import { getListPrice } from "~/feature/ProductDescriptor/v1/productDescriptorUtils";
import { PriceElements } from "~/common/components/Price/PriceV4";

export const ListPrice = (props: Omit<SelectPriceProps, "quantity">) => {
  const price = getListPrice(props);

  if (!price || !price.value) {
    return null;
  }

  return (
    <PriceElements.Stack>
      <PriceElements.Price price={price} variant="titleMedium" fontWeight={"bold"} />
      <PriceElements.ListPriceLabel unit={price!.unit} variant="labelLarge" />
    </PriceElements.Stack>
  );
};
